import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const bmrfitnessApiService = createApi({
  reducerPath: "bmrfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createBMR: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `bmrfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getBMR: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `bmrfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateBMR: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `bmrfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateBMRMutation, useGetBMRQuery, useUpdateBMRMutation } =
  bmrfitnessApiService;
